import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-screen pt-20 pb-16 px-4 md:px-8 bg-cream overflow-hidden flex flex-col justify-center" data-id="element-53">
      <div className="max-w-6xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-54">
        {/* Text Content */}
        <div className="flex flex-col items-start z-10" data-id="element-55">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-block px-3 py-1 mb-6 text-xs font-bold tracking-widest text-gold uppercase border border-gold/30 rounded-full bg-white/50" data-id="element-56">
            MÉTODO EXCLUSIVO ARGENTINA
          </motion.span>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brown-deep leading-[1.1] mb-6" data-id="element-57">
            ¿Inflamación o grasa?{' '}
            <span className="italic text-coral" data-id="element-58">Descubrí</span> por qué tu panza
            no baja y cómo lograr el{' '}
            <span className="relative inline-block" data-id="element-59">
              Efecto Vacío
              <svg className="absolute w-full h-3 -bottom-1 left-0 text-gold/40" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-60">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="3" fill="none" data-id="element-61" />
              </svg>
            </span>
            .
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-brown-medium mb-8 max-w-xl leading-relaxed" data-id="element-62">
            El sistema profesional de desinflamación abdominal que combina Faja
            Térmica Premium + Protocolo Digital 21D. Sin dietas extremas. Sin
            gimnasio.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col w-full sm:w-auto" data-id="element-63">
            <a href="#oferta" className="group relative w-full sm:w-auto px-8 py-4 bg-coral hover:bg-coral-dark text-white rounded-full font-bold text-lg shadow-lg shadow-coral/30 transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2 no-underline" data-id="element-64">
              <span className="relative z-10" data-id="element-65">QUIERO MI KIT VIENTRE PLANO</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-66" />
              <div className="absolute inset-0 rounded-full bg-white/20 animate-pulse-slow" data-id="element-67"></div>
            </a>

            <div className="mt-6 flex flex-wrap gap-4 text-sm text-brown-medium font-medium" data-id="element-68">
              <div className="flex items-center gap-1.5" data-id="element-69">
                <Check className="w-4 h-4 text-sage" data-id="element-70" />
                <span data-id="element-71">Envío a toda Argentina</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-72">
                <Check className="w-4 h-4 text-sage" data-id="element-73" />
                <span data-id="element-74">Stock disponible</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-75">
                <Check className="w-4 h-4 text-sage" data-id="element-76" />
                <span data-id="element-77">Garantía de satisfacción</span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Visual Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative flex justify-center lg:justify-end" data-id="element-78">
          <div className="relative w-full max-w-md aspect-[4/5] rounded-[2rem] overflow-hidden shadow-2xl" data-id="element-79">
            {/* Product Image */}
            <img src="https://cdn.magicpatterns.com/uploads/5Xi6dhnZ3kFkRNDwkcmitn/f01.png" alt="Kit Vientre Plano 21D - Antes y Después" className="absolute inset-0 w-full h-full object-cover" data-id="element-80" />

            {/* Floating Badge */}
            <div className="absolute top-6 right-6 bg-white/90 backdrop-blur-md px-4 py-2 rounded-full shadow-lg border border-gold/20" data-id="element-81">
              <span className="text-xs font-bold text-brown-deep tracking-wide" data-id="element-82">
                RESULTADOS EN 72HS
              </span>
            </div>
          </div>

          {/* Decorative Elements */}
          <div className="absolute -z-10 top-1/2 right-0 w-64 h-64 bg-rose rounded-full blur-3xl opacity-60 transform translate-x-1/3 -translate-y-1/2" data-id="element-83"></div>
          <div className="absolute -z-10 bottom-0 left-0 w-48 h-48 bg-gold/20 rounded-full blur-3xl opacity-60 transform -translate-x-1/4 translate-y-1/4" data-id="element-84"></div>
        </motion.div>
      </div>
    </section>;
}